<template>
  <div>
    <span v-if="isCategory">
      {{ params.data.open_domains_count }} Enabled / {{ params.data.blocked_domains_count }} Blocked
    </span>
    <span v-else>
      <span class="text-blue-500" v-if="params.data.status === 1">
        Enabled
      </span>
      <span class="text-red-700" v-if="params.data.status === 0">
        Blocked
      </span>
    </span>
  </div>
</template>

<script>
export default {
  computed: {
    isCategory () {
      return this.params.data.hasOwnProperty('open_domains_count')
    }
  }
}
</script>